import { useRouter } from '@fabric-app/compat';

const useHandleOpenAssetsPanel = () => {
  const router = useRouter();
  const { query, replace } = router;
  return (open) => {
    replace({
      query: {
        ...query,
        showAssetsPanel: open ? "true" : false
      }
    });
  };
};

export { useHandleOpenAssetsPanel };
//# sourceMappingURL=useOpenAssetsPanel.js.map
